import {
  GET_LIVE_STATISTICS_REQUEST,
  GET_LIVE_STATISTICS_SUCCESS,
  GET_LIVE_STATISTICS_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  if (action.type === GET_LIVE_STATISTICS_REQUEST) {
    return { ...state, isLoading: true, error: null };
  } else if (action.type === GET_LIVE_STATISTICS_SUCCESS) {
    return {
      ...state,
      data: { ...action.payload },
      isLoading: false,
      error: null
    };
  } else if (action.type === GET_LIVE_STATISTICS_FAILURE) {
    return { ...state, isLoading: false, error: action.payload };
  } else if (action.type === RESET_MATCH_CARD) {
    return { ...initialState };
  } else {
    return state;
  }
};
